module.exports = {
	"articleTitle1": "Ben & Jerry's and Stucchi's make it work",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Stucci's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/stucchis-perfect-spot-desserts-birthday-treats",
	"articleSnippet1": "Sep 25, 2007 ... Stucchi's had been an Ann Arbor favorite since the late 1980s. So obviously \nwhen Ben & Jerry's decided to move next door, it wasn't exactly an ...",
	"articleSnippet2": "Apr 14, 2004 ... Regardless of the changes Ann Arbor undergoes though, residents can always \ndepend on the perfection of Stucchi's tasty ice cream delights.",
	"foodRecommendations": [],
	"articleTitle2": "Stucchi's perfect spot for desserts, birthday treats",
	"address": "302 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279162,
		"lng": -83.741067
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/stucchis.json
// module id = 983
// module chunks = 0